import React, { createContext, useContext } from 'react';
import { SortConfig } from 'components/RecordsListView/types';
import useOperationSort from 'hooks/useOperationSort';

interface OperationSortContextType {
  sorts: SortConfig[];
  setSort: (sorts: SortConfig[]) => void;
  defaultSort: SortConfig[];
}

const OperationSortContext = createContext<
  OperationSortContextType | undefined
>(undefined);

export const OperationSortProvider: React.FC<{
  storageKey: string;
  defaultSort?: SortConfig[];
  children: React.ReactNode;
}> = ({ storageKey, defaultSort, children }) => {
  const sortState = useOperationSort(storageKey, defaultSort);

  return (
    <OperationSortContext.Provider value={sortState}>
      {children}
    </OperationSortContext.Provider>
  );
};

export const useOperationSortContext = () => {
  const context = useContext(OperationSortContext);
  if (!context) {
    throw new Error(
      'useOperationSortContext must be used within OperationSortProvider'
    );
  }
  return context;
};
